export default __webpack_public_path__ + "static/adultTraining-8c5d198c9408a731cef6bc79766275c5.jpg";